export default {
  firstName: {
    en: `Hi {firstName},<br />`,
  },
  text: {
    en: `
      You may have noticed that your Scentbird fragrance didn’t arrive on your doorstep this month.<br />
      It looks like we had some trouble charging your card and couldn’t ship your monthly selection.<br />
      Let’s fix this together - it should take no longer than 30 seconds to update your card information.<br />
    `,
  },
  textWithLEPInfo: {
    en: `
      It looks like we had some trouble charging your card.<br />
      Note that you have limited time offer products in your queue.<br />
      Update your payment information before {currentMonth}&nbsp;21st in order to ensure you receive the products.<br />
    `,
  },
  textWithLEPInfo1st: {
    en: `
      It looks like we had some trouble charging your card.<br />
      Note that you have limited time offer products in your queue.<br />
      Update your payment information before {currentMonth}&nbsp;27st in order to ensure you receive the products.<br />
    `,
  },
  textLEPNeedUpdateCard: {
    en: `
     We had some trouble charging your card.
     Update your payment information to add limited-time products to your queue and don’t miss out!<br />
    `,
  },
  subText: {
    en: 'Our birdie looks forward to delivering your next scent!',
  },
  button: {
    en: 'Update payment information',
  },
  contactInfo: {
    en: `
      If you have any questions, please contact us at:<br />
      support@scentbird.com
    `,
  },
  imageCaption: {
    en: `
      Mariya Nurislamova,<br/>
      Founder & CEO
    `,
  },
}
